import { createHead, useHead } from "@unhead/vue"
import { APP_INFO } from "~/../meta"
import { HoppModule } from "."

export default <HoppModule>{
  onVueAppInit(app) {
    const head = createHead()

    app.use(head)
  },

  onRootSetup() {
    // If the static index.html already sets a title (e.g. <title>OpenAPI Explorer</title>),
    // prefer that title so the app doesn't override it on boot. Keep SSR-safety by
    // checking for document existence.
    const currentTitle =
      typeof document !== "undefined" && document.title
        ? document.title.trim()
        : ""

    useHead({
      title: currentTitle || `${APP_INFO.name} • ${APP_INFO.shortDescription}`,
      titleTemplate(title) {
        // If the title equals the app name, don't append the app name again.
        return title === APP_INFO.name ? title : `${title}`
      },
    })
  },
}
